// extracted by mini-css-extract-plugin
module.exports = {"container":"EVsListItemComponent_container__G4SIz","borderRight":"EVsListItemComponent_borderRight__GwNAn","footer":"EVsListItemComponent_footer__xksvq"};